import { render, staticRenderFns } from "./AnswersButtons.vue?vue&type=template&id=0e5ed51c&scoped=true&"
import script from "./AnswersButtons.vue?vue&type=script&lang=js&"
export * from "./AnswersButtons.vue?vue&type=script&lang=js&"
import style0 from "./AnswersButtons.vue?vue&type=style&index=0&id=0e5ed51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5ed51c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
